import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPaintBrush, faCaretUp, faCaretDown, faKey, faLock, faLockOpen, faFile, faTimes, faSpinner, faQuestion, faLightbulb, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vueSmoothScroll from 'vue2-smooth-scroll'
import * as VueAos from 'vue-aos'

library.add(faPaintBrush);
library.add(faCaretUp);
library.add(faCaretDown);
library.add(faKey);
library.add(faLock);
library.add(faLockOpen);
library.add(faFile);
library.add(faTimes);
library.add(faSpinner);
library.add(faQuestion);
library.add(faLightbulb);
library.add(faCaretRight);
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(router);
Vue.use(vueSmoothScroll);
Vue.use(VueAos)

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'vue2-animate/dist/vue2-animate.min.css';

Vue.config.productionTip = false

import CommonInstall from './components/commons/regCommonComponents.js'
CommonInstall.install(Vue);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
